// src/components/layout/CenteredLogo.jsx
import React, { useState } from "react";

export default function CenteredLogo({ label = "Alkeme UX", size = 120 }) {
  const [hideImg, setHideImg] = useState(false);

  return (
    <div className="logo-wrap" style={{ textAlign: "center" }}>
      {!hideImg ? (
        <img
          src={`${process.env.PUBLIC_URL}/Icon.svg`}
          alt="Logo"
          className="logo-center"
          style={{ width: size, height: size }}
          onError={() => setHideImg(true)}
        />
      ) : (
        <div
          className="logo-fallback"
          style={{
            fontSize: size * 0.3,
            fontWeight: 600,
            opacity: 0.8,
            letterSpacing: "-0.5px",
          }}
        >
          {label}
        </div>
      )}
    </div>
  );
}